import { gql } from 'apollo-angular';

export const shareTemplateForInteraction = gql`
  query getShareTemplate($params: String) {
    shareTemplateForInteraction(params: $params)
  }
`;
